(function(){
'use strict';

angular.module('classy.frs').run(['$templateCache', function ($templateCache) {
  $templateCache.put('frs/shared/supporter/pages/updates/scDashboardNotification', '<div class="{{ customClass }}_confirmation">\n' + '  <p>Notification meassage</p>\n' + '</div>\n' + '');
}]);
})();